export default ['$q',
    'JsonRPCService', ($q, JsonRPCService) => {
        return {
            getPolicyDiffWithPrevious: (jobNumber) => {
                return JsonRPCService.send('pc', 'policydiff/policydiff', 'getPolicyDiffWithPrevious', [jobNumber]);
            }
        };
    }
];

